import { render, staticRenderFns } from "./CategoryHeader.vue?vue&type=template&id=16775597"
import script from "./CategoryHeader.vue?vue&type=script&lang=js"
export * from "./CategoryHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TlmContainer: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/TlmContainer.vue').default})
